
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Module for the sidebar menu items

Author: Deimos Space UK

Version: 1.0
*/
export const SIDEBAR_MENU = [
	{
		path: "",
		title: "MAIN.SIDENAV.ITEMS.MISSIONS_DEFINITION_REVIEW.MAIN",
		//icon: "mdi mdi-shield-star",
		submenu: [
			{
				path: "/existing-missions",
				title: "MAIN.SIDENAV.ITEMS.MISSIONS_DEFINITION_REVIEW.EXISTING",
				//icon: "mdi mdi-satellite-variant",
				submenu: [],
			},
			{
				path: "/planned-missions",
				title:'MAIN.SIDENAV.ITEMS.MISSIONS_DEFINITION_REVIEW.PLANNED',
				//icon: "mdi mdi-calendar",
				submenu: [],
			},
		],
	},
	{
		path: "/impact-evaluation/input",
		title: "MAIN.SIDENAV.ITEMS.IMPACT_EVALUATION",
		//icon: "mdi mdi-rocket",
		submenu: [],
	},

];
